module.exports = __webpack_public_path__ + "img/CS-UL-I_Overview-Rear_1.e3853cdf.jpg";